import { formatDate } from './formatUtils';

const getQualificationByType = (academicQualifications, qualificationType) => {
  if (!Array.isArray(academicQualifications)) return null;
  return academicQualifications.find(
    (qualification) =>
      (qualification.qualificationType || '').toLowerCase() === qualificationType.toLowerCase()
  );
};

const getHighestQualification = (academicQualifications) => {
  if (!Array.isArray(academicQualifications) || academicQualifications.length === 0) {
    return null;
  }
  return academicQualifications.find((qualification) => qualification.isHighestDegree) || academicQualifications[0];
};

const formatPercentage = (qualification) => {
  const value = qualification?.percentageCgpa;
  if (value === null || value === undefined || value === '') return '—';
  return `${value}%`;
};

export const mapEnrollmentStudentDetails = (enrollment) => {
  const student = enrollment?.student || {};
  const academicQualifications = student.academicQualifications || [];
  const highestQualification = getHighestQualification(academicQualifications);
  const tenthQualification = getQualificationByType(academicQualifications, '10th');
  const twelfthQualification = getQualificationByType(academicQualifications, '12th');

  return {
    header: {
      id: enrollment?.id || '',
      fullName: student.fullName || 'Unknown Student',
      email: student.emailAddress || 'N/A',
      enrolledOn: formatDate(enrollment?.enrollmentDate),
      batchStatus: enrollment?.batchStatus || null
    },
    personal: {
      phoneNumber: student.phoneNumber || '—',
      currentAddress: student.currentAddress || '—',
      domainName: student.domain?.domainName || '—'
    },
    enrollment: {
      batchStatus: enrollment?.batchStatus || '—',
      placementStatus: enrollment?.placementStatus || '—',
      attendancePercentage: enrollment?.attendancePercentage || '—',
      courseCompletionDate: formatDate(enrollment?.courseCompletionDate)
    },
    academic: {
      highestDegree: highestQualification?.qualificationType || '—',
      highestDegreePercentage: formatPercentage(highestQualification),
      tenthPercentage: formatPercentage(tenthQualification),
      twelfthPercentage: formatPercentage(twelfthQualification)
    }
  };
};

